import React, { Component } from 'react';

class Summary extends Component {
  render() {
    const paragraphs = this.props.children.split('\n');
    return(
      paragraphs.map((item, i) =>
        <p key={i}>{item}</p>
      )
    )
  }
}
export default Summary;
